// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"d80252e0","472":"bcf03bf8","496":"cc1b7ac5","572":"18dc6e2a","591":"e3ef1548","647":"4bf6b372","723":"ecaa6434","795":"b235c243","864":"448ed12a","972":"2e361a45","988":"dce72a5d"}[chunkId] + ".chunk.js";
};